<template>
  <router-view name="marketplace" v-bind:key="$route.path"></router-view>
</template>

<script>
export default {
  name: "Marketplace",
};
</script>
